import { JIRA_SUPPORT_REPORT_ISSUE_LINK } from 'constants/links'
import { HelpLink } from 'elements/link/HelpLink'
import { Link } from 'opensolar-ui'
import useTranslateParse from '../../../util/useTranslateParse'

const OtherSubtitle = () => {
  const translateParse = useTranslateParse()
  return (
    <span>
      {translateParse(
        "Search our extensive database, and add other components to your 'active' list so your team can use them to design. Non-admins do not have the ability to search the database and can only use equipment on this list. If any equipment is missing from the database, <supportLink>contact OpenSolar Support<supportLink> and we will add it, or you can create your own.",
        {
          supportLink: (label) => (
            <Link href={JIRA_SUPPORT_REPORT_ISSUE_LINK} target="_blank" rel="noreferrer">
              {label}
            </Link>
          ),
        }
      )}
      <HelpLink href="https://support.opensolar.com/hc/en-us/articles/12363053307663-How-to-add-your-hardware-components" />
    </span>
  )
}
const ActiveOthersName = ({ translate, style }) => {
  return <span style={style}>{translate('Edit Other Component')}</span>
}
export default {
  list: { lazy: () => import('./activeOthers'), component: 'ActiveOthersList' },
  edit: { lazy: () => import('./activeOthers'), component: 'ActiveOthersEdit' },
  create: { lazy: () => import('./activeOthers'), component: 'ActiveOthersCreate' },
  options: {
    create: {
      title: 'Other Component Activation',
      subtitle: null,
      breadCrumb: 'Component Activation',
    },
    list: {
      title: 'My Active Other Components List',
      subtitle: <OtherSubtitle />,
      breadCrumb: 'Other Components',
    },
    edit: {
      title: <ActiveOthersName />,
      subtitle: null,
      breadCrumb: 'Edit Component',
    },
  },
}
